import { computed } from '@preact/signals-react'

import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'

const CreateProfileFromConfigModal = function ({ showSignal, newProfileNameSignal, nameAlreadyUsedComputed, handleSubmit, utgNickname }) {

    const handleCloseModal = () => {
        showSignal.value = false
        newProfileNameSignal.value = ''
    }

    const disableSubmitSignal = computed(
        () => {
            return (newProfileNameSignal.value.length == 0 || nameAlreadyUsedComputed.value)
        }
    )

    return (
        <Modal show={showSignal.value} onHide={handleCloseModal}>
            <Modal.Header closeButton>
                <Modal.Title>Create Profile from {utgNickname}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Enter a name for the new profile. All configuration settings from this UTG will be copied into the profile.</p>
                <Form>
                    <Form.Group className="mb-3" controlId="createProfileFromConfigName">
                        <Form.Label>Profile Name</Form.Label>
                        <Form.Control
                            type="text"
                            required
                            onInput={(e) => newProfileNameSignal.value = e.target.value}
                            autoFocus
                            value={newProfileNameSignal.value}
                        />
                        <p className="mt-1" hidden={!nameAlreadyUsedComputed.value}>Profile name must be unique</p>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleCloseModal}>
                    Cancel
                </Button>
                <Button disabled={disableSubmitSignal.value} variant="primary" onClick={handleSubmit}>
                    Create Profile
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
export default CreateProfileFromConfigModal
